export const GAMEPLAY_PC_HEADER_BAR_GAMEMODE_LABEL_WIDTH = "150px";